<template>
    <div class="search-filter-temperature">
        <a href="#" :class="['filter-button', {focus, active}]" @click.prevent="toggleFocus">{{ title }}</a>
        
        <div v-if="focus" class="filter-box shadow">
            <div class="thermometer">
                <div v-for="color in thermometerColors" :key="color" :style="`background-color: ${color}`"></div>
            </div>
            <vue-slider class="mt-3 ml-2 mr-2 mb-5" 
                        v-model="options[0].value" 
                        :enable-cross="false" 
                        :min="options[0].min" 
                        :max="options[0].max" 
                        :tooltip="'always'"
                        tooltipPlacement="bottom"
                        :tooltip-formatter="val => val + '°'"
                        :use-keyboard="false">
            </vue-slider>
            
            <hr>
            
            <div class="row align-items-center">
                <div class="col">
                    <a href="#" @click.prevent="clear" class="clear-button text-muted">Clear</a>
                </div>
                <div class="col text-right">
                    <a href="#" @click.prevent="save" class="save-button btn btn-primary">Save</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/eventBus'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    name: 'SearchFilterTemperature',
    components: {
        VueSlider,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            checked: false,
            focus: false,
            value: [this.options[0].min, this.options[0].max],
            thermometerColors: [
                '#41CDED',
                '#4DC2DB',
                '#53BBD0',
                '#5FAEBC',
                '#6DA1A7',
                '#769798',
                '#838A84',
                '#8E7F72',
                '#987461',
                '#A4674D',
                '#AE5D3D',
                '#BA512A',
                '#C84213',
            ],
        }
    },
    computed: {
        active() {
            return this.options[0].value[0] != this.options[0].min || this.options[0].value[1] != this.options[0].max
        },
    },
    methods: {
        toggleFocus() {
            if (this.focus) {
                this.close()
            } else {
                this.open()
            }
        },
        open() {
            EventBus.$emit('close-all-filter-buttons', this);
            this.focus = true
        },
        close(save = true) {
            if (save) {
                this.$emit('save-filters')
            }
            this.focus = false
        },
        save() {
            this.close()
        },
        clear() {
            this.options[0].value = [this.options[0].min, this.options[0].max]
            this.close()
        },
    },
    created() {
        EventBus.$on('close-all-filter-buttons', vm => {
            if (vm._uid != this._uid) {
                this.close(false)
            }
            
            EventBus.$on('clear-all-filters', () => {
                this.clear();
            });
        });
    },
};
</script>

<style lang="scss">
.search-filter-temperature {
    position: relative;
    display: inline-block;
    
    .filter-button {
        display: inline-block;
        border: 1px solid $light-gray;
        border-radius: 4px;
        background: $almost-white;
        padding: 4px 12px;
        color: $almost-black;
        
        &:hover {
            text-decoration: none;
        }
        
        &.focus {
            background: $dark-gray;
            color: $almost-white;
        }
        
        &.active {
            background: $almost-black;
            color: $almost-white;
        }
    }
    
    .filter-box {
        position: absolute;
        z-index: 1000;
        background: $almost-white;
        padding: 15px;
        white-space: nowrap;
        top: calc(100% + 9px);
        left: 1px;
        border: 1px solid $lightest-gray;
        border-radius: 4px;
        
        .thermometer {
            width: 300px;
            height: 46px;
            overflow: hidden;
            border-radius: 80px;
            
            div {
                width: calc(100%/13);
                height: 100%;
                display: inline-block;
                
                &:not(:first-child) {
                    border-left: 1px solid white;
                }
                
                &:not(:last-child) {
                    border-right: 1px solid white;
                }
            }
        }
        
        .vue-slider-process {
            background-color: $almost-black;
        }
        .vue-slider-dot-tooltip-inner {
            border-color: $almost-black;
            background-color: $almost-black;
        }
    }
}
</style>